// Shared with i18next-browser-languagedetector (lookupLocalStorage default).
export const I18N_LANGUAGE_STORAGE_KEY = 'i18nextLng'

export const supportedLanguages = {
  en: {
    id: 'en',
    value: 'en',
    text: 'English',
    active: true,
  },
  es: {
    id: 'es',
    value: 'es',
    text: 'Spanish',
    active: false,
  },
  fr: {
    id: 'fr',
    value: 'fr',
    text: 'French',
    active: false,
  },
  it: {
    id: 'it',
    value: 'it',
    text: 'Italian',
    active: false,
  },
  nl: {
    id: 'nl',
    value: 'nl',
    text: 'Dutch',
    active: false,
  },
  da: {
    id: 'da',
    value: 'da',
    text: 'Danish',
    active: false,
  },
  de: {
    id: 'de',
    value: 'de',
    text: 'German',
    active: false,
  },
}
